import { render, staticRenderFns } from "./OpenboxContable.vue?vue&type=template&id=dbeb2972&"
import script from "./OpenboxContable.vue?vue&type=script&lang=js&"
export * from "./OpenboxContable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports